// require('slick-carousel');
// var scrollIntoView = require('scroll-into-view');

let primaryTimeline = $('.timeline-primary'),
    timelineNav = $('.timeline-nav'),
    timelineNavItems = $('.timeline-nav-item'),
    primaryEvents = $('.timeline-primary-events'),
    prevNav = $('.timeline-prev'),
    nextNav = $('.timeline-next'),
    prevNavLabel = $('.timeline-prev .timeline-nav-label'),
    nextNavLabel = $('.timeline-next .timeline-nav-label'),
    moreMilestonesButton = $('.more-milestones-button'),
    closeMoreMilestonesButton = $('.more-milestones-close');

primaryTimeline.slick({
    centerMode: true,
    centerPadding: '0',
    infinite: false,
    arrows: false,
    asNavFor: primaryEvents
});

primaryEvents.slick({
    fade: true,
    asNavFor: primaryTimeline,
    arrows: false
});

prevNav.on('click', function () {
    primaryTimeline.slick('slickPrev');
});

nextNav.on('click', function () {
    primaryTimeline.slick('slickNext');
});

timelineNavItems.on('click', function () {
    timelineNavItems.not($(this)).removeClass('active');
    $(this).addClass('active');
    primaryTimeline.slick('slickGoTo', $(this).data('index'));
});

primaryTimeline.on('afterChange', function (event, slick, currentSlide) {

    let timelineItem = $('.timeline-item-' + currentSlide);

    prevNavLabel.text(timelineItem.data('previous-label'));
    nextNavLabel.text(timelineItem.data('next-label'));

    $('.timeline-nav-item').not($('.timeline-nav-item-' + currentSlide)).removeClass('active');
    $('.timeline-nav-item-' + currentSlide).addClass('active');

    // check timeline nav scroll position and adjust
    // console.log(timelineNav.outerWidth());
    // console.log(timelineNav.offset().left);
    // console.log($('.timeline-nav-item-' + currentSlide).offset().left);
    // console.log(timelineNav.scrollLeft());

    // console.log('----')
    // console.log($('.timeline-nav-item-' + currentSlide).offset().left);
    // console.log(timelineNav.offset().left);
    // console.log(timelineNav.scrollLeft());
    // console.log(timelineNav.outerWidth() - timelineNav.scrollLeft());
    // console.log('----E')

    // $('.timeline-nav-item-' + currentSlide)[0].scrollIntoView({
    //     behavior: "smooth",
    //     block: "end",
    //     inline: 'center'
    // });

    // scrollIntoView($('.timeline-nav-item-' + currentSlide)[0], {
    //     align:{
    //         lockY: true,
    //     }
    // });

    // timelineNav.animate({
    //     scrollLeft: $('.timeline-nav-item-' + currentSlide).offset().left - timelineNav.offset().left
    // }, 500);

    // if(($('.timeline-nav-item-' + currentSlide).offset().left - timelineNav.offset().left) >= timelineNav.outerWidth()) {
    //     console.log('is too far right');
    //     timelineNav.animate({
    //         scrollLeft: $('.timeline-nav-item-' + currentSlide).offset().left - timelineNav.offset().left
    //     }, 500);
    // } else if(($('.timeline-nav-item-' + currentSlide).offset().left - timelineNav.offset().left) < timelineNav.scrollLeft()) {
    //     console.log('is too far left');
    //     // console.log(timelineNav.scrollLeft() - $('.timeline-nav-item-' + currentSlide).outerWidth());
    //     // console.log($('.timeline-nav-item-' + currentSlide).offset().left);
    //     // console.log($('.timeline-nav-item-' + currentSlide).offset().left);
    //     // console.log(timelineNav.offset().left);
    //     // console.log(timelineNav.scrollLeft());
    //     timelineNav.animate({
    //         scrollLeft: $('.timeline-nav-item-' + currentSlide).offset().left - timelineNav.offset().left
    //     }, 500);
    // }

    if(currentSlide === 0) {
        prevNav.addClass('hiding');
        nextNav.removeClass('hiding');
    } else if((currentSlide + 1) === slick.slideCount) {
        prevNav.removeClass('hiding');
        nextNav.addClass('hiding');
    } else {
        prevNav.removeClass('hiding');
        nextNav.removeClass('hiding');
    }

});

moreMilestonesButton.on('click', function () {
    let popup = $('.more-milestones-popup-' + $(this).data('index'));

    popup.removeClass('hidden');
    setTimeout(function () {
        popup.removeClass('hiding');
    }, 50);
});

closeMoreMilestonesButton.on('click', function () {
    let popup = $(this).parent();

    popup.addClass('hiding');
    setTimeout(function () {
        popup.addClass('hidden');
    }, 350);
});
